import React, { useState, useEffect } from 'react';
import './TinderCard.css';
import TinderCard from 'react-tinder-card';
import database from './firebase';

const Tindercard = () => {

    const [people, setPeople] = useState([]);


    useEffect(() => {
        database.collection('people').onSnapshot(snapshot => (
            setPeople(snapshot.docs.map(doc => doc.data()))
        ))
    }, []);


    // const swiped = (direction, nameToDelete) => {
    //     console.log("removing:" + nameToDelete);
    //     // setLastDirection(direction);
    // }

    // const outOfFrame = (name) => {
    //     console.log(name + "left the screen");
    // }

    return (
        <div className='tinder-card'>
            <div className='tinder-card-container'>
                {people.map((person) => {
                    return <TinderCard
                        className='swipe'
                        key={person.name}
                        preventSwipe={["up", "down"]}>
                        <div
                            style={{ backgroundImage: `url(${person.url})` }}
                            className='card'>
                            <h3>{person.name}</h3>
                        </div>
                    </TinderCard>
                })}
            </div>
        </div>
    )
}

export default Tindercard;
